import { baseStyle } from "./BrandDivider.styles";

export const BrandDivider = ({ text = undefined }) => {
  return (
    <div style={baseStyle} >
      {text}
    </div>
  );
};

export default BrandDivider;